import React, { Component } from "react";
import { Box, Button } from "@mui/material";
import instance from "../../axios";
import Loader from "../../Layout/Loader";
import { getCompanyById } from "../../Helpers";
import {
  BayanatDeliveryNoteMui,
  mapCashCustomerInvoiceToDoc,
  mapManualInvoiceToDoc,
  isManualInvoiceCreation,
  printMuiDoc,
  fetchAccountTermsSetting,
  resolveContractNumber,
} from "../../Components/Documents";

let serverTimeZoneName = "";

const resolveTimezoneFromQuery = (raw) => {
  try {
    return decodeURIComponent((raw || "").split("&")[0]) || "Asia/Riyadh";
  } catch (e) {
    return (raw || "").split("&")[0] || "Asia/Riyadh";
  }
};

/** Other Customers (cashinvoices) — cash-customer-invoice.html */
class CashCustomerInvoiceDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data1: {},
      loader: false,
      company: null,
      didAutoPrint: false,
    };
  }

  componentWillMount() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    const queryString = window.location.search;
    const res = queryString.split("?&token=");
    const parts = (res[1] || "").split("&timezone=");
    const invoiceId = (parts[0] || "").split("&")[0];
    serverTimeZoneName = resolveTimezoneFromQuery(parts[1]);

    this.setState({ loader: true }, () => {
      instance({
        method: "GET",
        url: `/api/cashinvoices/${invoiceId}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then(async (response) => {
          const data1 =
            response && typeof response === "object" && !Array.isArray(response)
              ? response
              : {};
          const companyId = data1?.companyId || userInfo?.companyId;
          if (companyId) {
            getCompanyById(companyId)
              .then((company) => this.setState({ company }))
              .catch((error) => console.error(error.message));
          }
          const cn = resolveContractNumber(data1);
          const setting =
            (await fetchAccountTermsSetting(cn)) || data1?.setting || null;
          this.setState({
            data1: { ...data1, setting },
            loader: false,
          });
        })
        .catch((error) => {
          console.log("error ====", error);
          this.setState({ loader: false });
        });
    });
  }

  componentDidUpdate() {
    this.maybeAutoPrint();
  }

  replaceAmpersands(obj) {
    if (!obj || typeof obj !== "object") return;
    for (const prop in obj) {
      if (typeof obj[prop] === "string") {
        obj[prop] = obj[prop].replace(/amp;/g, "");
      } else if (typeof obj[prop] === "object" && obj[prop] !== null) {
        this.replaceAmpersands(obj[prop]);
      }
    }
  }

  buildDoc() {
    const { data1, company } = this.state;
    if (!data1 || !Object.keys(data1).length) return null;
    const data = data1;
    this.replaceAmpersands(data);
    if (isManualInvoiceCreation(data)) {
      return mapManualInvoiceToDoc(data, company, {
        timezone: serverTimeZoneName,
      });
    }
    return mapCashCustomerInvoiceToDoc(data, company, {
      timezone: serverTimeZoneName,
    });
  }

  maybeAutoPrint() {
    const params = new URLSearchParams(window.location.search);
    const autoPrint = params.get("autoPrint");
    const { loader, data1, didAutoPrint } = this.state;
    if (
      loader ||
      !data1 ||
      !Object.keys(data1).length ||
      didAutoPrint ||
      !autoPrint
    ) {
      return;
    }
    this.setState({ didAutoPrint: true }, () => {
      const doc = this.buildDoc();
      printMuiDoc({ title: doc?.titleEn || "Tax Invoice" }).then(() => {
        window.onafterprint = () => {
          try {
            window.close();
          } catch (e) {
            // ignore
          }
        };
      });
    });
  }

  handlePrint = () => {
    const doc = this.buildDoc();
    printMuiDoc({ title: doc?.titleEn || "Tax Invoice" });
  };

  handleClose = () => {
    try {
      window.close();
    } catch (e) {
      // ignore
    }
  };

  render() {
    const { loader, data1 } = this.state;
    if (loader || !data1 || !Object.keys(data1).length) {
      return <Loader component="filter" />;
    }
    const params = new URLSearchParams(window.location.search);
    const hideChrome = params.get("autoPrint");
    return (
      <Box>
        {!hideChrome && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              p: 1.5,
              "@media print": { display: "none" },
            }}
          >
            <Button variant="contained" onClick={this.handlePrint}>
              Print
            </Button>
            <Button variant="outlined" onClick={this.handleClose}>
              Close
            </Button>
          </Box>
        )}
        <BayanatDeliveryNoteMui doc={this.buildDoc()} hideToolbar />
      </Box>
    );
  }
}

export default CashCustomerInvoiceDetail;
